module.exports = __webpack_public_path__ + "img/card_ip_stipulation49.737257b9.svg";